import { useState, useEffect } from "react";
import axios from "axios";
import { useRouter } from "next/router";
import CryptoJS from "crypto-js";

import Header from "../components/Header/Header";
import Banner from "../components/MainWebsiteComponent/Banner/Banner";
import Aboutus from "../components/MainWebsiteComponent/AboutUs/AboutUs";
import BecomeaTeacher from "../components/MainWebsiteComponent/BecomesTeacherSec/BecomesTeacherSec";
import Faq from "../components/Faq/Faq";
import Footer from "../components/MainWebsiteComponent/Footer/Footer";

import ExploreCourse from "../components/MainWebsiteComponent/ExploreCourse/ExploreCourse";
import LearnFromOurTeacher from "../components/MainWebsiteComponent/LearnFromOurTeacher/LearnFromOurTeacher";
import InstitutionsTeaching from "../components/MainWebsiteComponent/InstitutionsTeaching/InstitutionsTeaching";
import SimpleBackdrop from "../components/Backdrop/SimpleBackdrop";
import CustomizedSnackbar from "../hooks/Snackbar";
import Head from "next/head";
import Script from "next/script";
import OthersProducts from "../components/MainWebsiteComponent/OthersProducts/OthersProducts";
import { useShoppingCart } from "../contexts/CartContext";
import StickyFooter from "../components/StickyFooter/StickyFooter";
import { useUserData } from "../hooks/HelperFunctions";
import BlogListing from "../components/BlogCard/BlogCard";
import BlogHome from "../components/BlogHome/BlogHome";
import FeaturedTeaching from "../components/MainWebsiteComponent/FeaturedTeaching/FeaturedTeaching";
import UpcomingCourses from "../components/MainWebsiteComponent/UpcomingCourses/UpcomingCourses";
import InstallationPrompt from "../components/InstallationPrompt/InstallationPrompt";
import LearnSunnahFromScholars from "../components/MainWebsiteComponent/LearnSunnahFromScholars/LearnSunnahFromScholars";
import { jwtDecode } from "jwt-decode";
import ExploreTrstCourses from "../components/MainWebsiteComponent/ExploreCourse/ExploreTrstCourses";

const MyTakbirHome = (props) => {
  const { filterCheckBoxData } = props;

  const {
    subdomain,
    updateCart,
    setUpdateCart,
    openSignUpModel,
    setOpenSignUpModel,
    enrollNowHandler,
    showSnackbarMessage,
  } = props;

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // severity can be: success, error, warning, info, success
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [userData, setUserData] = useState({});
  const { cartItems } = useShoppingCart();
  const router = useRouter();

  const { signinToken, targetPage, userEmailVerificationToken, token } =
    router.query;

  /**
   * When click on snackbar close btn
   */
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowSnackbar(false);
  };

  // console.log(signinToken);
  // console.log(targetPage);

  const showEmailVerifyMessage = (result) => {
    console.log(result);

    const response = result.data;

    setOpenBackdrop(false);

    console.log(response.message);

    if (response.error) {
      // showSnackbarMessage("error", response.message);
      setSnackbarSeverity("error");
      setSnackbarMessage(response.message);
      setShowSnackbar(true);
    } else {
      console.log(response.message);
      // showSnackbarMessage("success", response.message);
      setSnackbarSeverity("success");
      setSnackbarMessage(response.message);
      setShowSnackbar(true);
      localStorage.setItem("userVerified", true);
    }

    setTimeout(() => {
      // goto home page and reload
      window.location.replace(window.location.origin);
    }, 3000);
  };

  const userEmailVerification = (token) => {
    const userVerified = localStorage.getItem("userVerified");

    if (userVerified) {
      setSnackbarSeverity("success");
      setSnackbarMessage("Email already verified");
      setShowSnackbar(true);
    } else {
      const baseUrl =
        process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
          ? process.env.NEXT_PUBLIC_API_URL_PROD
          : process.env.NEXT_PUBLIC_API_URL_DEV;
      setOpenBackdrop(true);
      axios
        .post(`${baseUrl}/verifyEmail`, { token: token })
        .then((response) => showEmailVerifyMessage(response))
        .catch((err) => {
          console.log(err);
          if (err.response.data.message) {
            // showSnackbarMessage("error", err.response.data.message);
            setSnackbarSeverity("error");
            setSnackbarMessage(err.response.data.message);
            setShowSnackbar(true);
          }
        });
    }
  };

  const redirectToTargetPage = (result) => {
    const response = result.data;

    setOpenBackdrop(false);

    if (response.error) {
      setSnackbarSeverity("error");
      setSnackbarMessage("Sign in failed, token is not valid");
      setShowSnackbar(true);
      console.log("Sign in failed, token is not valid");
    } else {
      const userData = {
        id: response.body.id,
        firstName: response.body.first_name,
        lastName: response.body.last_name,
        email: response.body.email,
        phone_number: response.body.phone_number,
        image: response.body.image,
        // "orgId": response.body.org_id,
        userRole: response.body.user_role,
      };

      const decoded = jwtDecode(response?.data?.jwt_token);
      localStorage.setItem("token_exp", decoded.exp * 1000);

      // set user data and user access token
      localStorage.setItem("userData", JSON.stringify(userData));
      localStorage.setItem("userToken", response.token);
      localStorage.setItem("jwtToken", response?.data?.jwt_token);
      // set user as authorized
      localStorage.setItem("userAuthenticated", true);
      // set user id related data
      // localStorage.setItem('orgId', response.body.org_id);
      // localStorage.setItem('stuId', response.body.stuId);
      // user acc verification data
      const userVerified = !response.body.email_verified_at ? false : true;
      localStorage.setItem("userVerified", userVerified);

      // if(response?.orgData?.subDomain){
      //   localStorage.setItem('subDomain', response.orgData.subDomain);
      // }

      if (response?.body?.timezone) {
        localStorage.setItem("timezone", response.body.timezone);
      }

      // show success message
      setSnackbarSeverity("success");
      setSnackbarMessage("Sign in Success!");
      setShowSnackbar(true);

      if (!targetPage || targetPage == "") {
        return false;
      }
      setTimeout(() => {
        // Redirects to portal page
        if (token) {
          window.location.href = `/`;
        } else {
          window.location.href = `/${targetPage}`;
        }
      }, 2000);
    }
  };

  const signInHandler = (userData) => {
    const baseUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_API_URL_PROD
        : process.env.NEXT_PUBLIC_API_URL_DEV;

    const userToken = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = `Bearer ${userToken}`;
    setOpenBackdrop(true);
    axios
      .post(`${baseUrl}/tokenBasedLogin`, userData)
      .then((response) => redirectToTargetPage(response, true))
      .catch((err) => {
        console.log(err);
        setOpenBackdrop(false);
        if (err.response.data.message) {
          console.log(err.response.data.message);
          setSnackbarSeverity("error");
          setSnackbarMessage(err.response.data.message);
          setShowSnackbar(true);
        }
      });
  };

  useEffect(() => {
    if (token) {
      try {
        const userTokenData = token.split(" ").join("+");
        const bytes = CryptoJS.AES.decrypt(
          userTokenData,
          "login-854256-secret-key"
        );

        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        if (decryptedData) {
          const userAuthData = decryptedData[0];
          const authDataObj = {
            email: userAuthData.email,
            phone_number: userAuthData.phone_number,
            userToken: userAuthData.userToken,
          };
          const decoded = jwtDecode(response?.data?.jwt_token);
          localStorage.setItem("token_exp", decoded.exp * 1000);

          localStorage.setItem("userToken", response?.data?.token);
          localStorage.setItem("jwtToken", response?.data?.jwt_token);

          signInHandler(authDataObj, true);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, [token]);

  useEffect(() => {
    if (signinToken) {
      try {
        const token = signinToken.split(" ").join("+");
        const bytes = CryptoJS.AES.decrypt(
          token,
          "token-based-signin-aglbnd-854256-secret-key"
        );
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        if (decryptedData) {
          console.log(decryptedData);
          // const userAuthData = decryptedData[0];
          const authDataObj = {
            email: decryptedData.email,
            userToken: decryptedData.userToken,
          };

          const decoded = jwtDecode(response?.data?.jwt_token);
          localStorage.setItem("token_exp", decoded.exp * 1000);

          localStorage.setItem("userToken", decryptedData.userToken);
          localStorage.setItem("jwtToken", response?.data?.jwt_token);
          signInHandler(authDataObj, true);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, [signinToken]);

  useEffect(() => {
    if (userEmailVerificationToken) {
      userEmailVerification(userEmailVerificationToken);
    }
  }, [userEmailVerificationToken]);

  useEffect(() => {
    if (cartItems?.length > 0) {
      const findOnlyCourses = cartItems?.filter((course) => course?.courseId);
      localStorage.setItem("selectedCourses", JSON.stringify(findOnlyCourses));
    }
  }, [cartItems]);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("userData")) || {};
    if (Object.keys(data).length > 0) {
      setUserData(data);
    }
    const token = localStorage.getItem("userToken");
    if (token === null) {
      setUserData({});
    }
  }, [localStorage.getItem("userToken")]);
  const faqData = [
    {
      id: "1",
      qus: "What is Takbir?",
      ans: (
        <div>
          <div style={{ fontWeight: "600", marginBottom: "8px" }}>
            Takbir is the world’s first online platform made to learn and teach
            Islam.
          </div>
          <div>
            It connects learners with trusted scholars and teachers of our Deen
            from around the world. You can join live or pre-recorded classes in
            different languages and explore topics that help you grow in faith,
            knowledge, and practice, all in one place.
          </div>
        </div>
      ),
    },

    {
      id: "2",
      qus: "Who can join Takbir?",
      ans: (
        <div>
          <div style={{ fontWeight: "600", marginBottom: "8px" }}>
            Anyone eager to learn, teach, and grow in Deen can join Takbir.
          </div>
          <div>
            Whether you’re a student, a teacher, a parent, a new Muslim, or
            simply curious,Takbir is open to everyone who wants to gain
            authentic knowledge and connect with reliable scholars and learners.{" "}
            <a style={{ color: "#004FE0" }} href="https://mytakbir.com/">
              {" "}
              Create your free account
            </a>{" "}
            to get started!
          </div>
        </div>
      ),
    },

    {
      id: "3",
      qus: "What kind of courses are available at Takbir?",
      ans: (
        <div>
          <div style={{ fontWeight: "600", marginBottom: "8px" }}>
            Teachers at Takbir offer a wide range of Islamic and value-based
            courses.
          </div>
          <div>
            You can learn about Qur’an, Hadith, Fiqh, Mental Health, Parenting,
            Islamic Marriage, Islamic History, Leadership, and much more - all
            taught in light of Islamic principles by experienced teachers. Check
            the available{" "}
            <a style={{ color: "#004FE0" }} href="https://mytakbir.com/search">
              {" "}
              courses at Takbir!
            </a>
          </div>
        </div>
      ),
    },

    {
      id: "4",
      qus: "Are the courses live or pre-recorded?",
      ans: (
        <div>
          <div style={{ fontWeight: "600", marginBottom: "8px" }}>
            Courses on Takbir are offered by teachers in both formats; live and
            pre-recorded.
          </div>
          <div>
            Live sessions let you interact with teachers in real time, while
            pre-recorded courses give you the flexibility to learn at your own
            pace, anytime, anywhere.
          </div>
        </div>
      ),
    },

    {
      id: "5",
      qus: "Do I need to pay to take a course on Takbir?",
      ans: (
        <div>
          <div style={{ fontWeight: "600", marginBottom: "8px" }}>
            Takbir offers both free and paid courses.
          </div>
          <div>
            You can choose what suits your needs and budget. Many scholars also
            offer valuable knowledge for free, while some courses may have a
            small fee to support their time and effort.
          </div>
        </div>
      ),
    },

    {
      id: "6",
      qus: "Who teaches the courses on Takbir?",
      ans: (
        <div>
          <div style={{ fontWeight: "600", marginBottom: "8px" }}>
            Courses on Takbir are taught by trusted scholars, teachers, and
            experts from around the world.{" "}
          </div>
          <div>
            {" "}
            If you have knowledge to share and a passion to teach, you can{" "}
            <a style={{ color: "#004FE0" }} href="https://mytakbir.com/teach">
              become a teacher at Takbir.
            </a>{" "}
            You are welcome to create meaningful Islamic and values-based
            courses in any language.
          </div>
        </div>
      ),
    },

    {
      id: "7",
      qus: "Is there any cost to publish a course?",
      ans: (
        <div>
          <div>
            No, there is absolutely no cost to publish your course on Takbir.
            It's free to join and start teaching. You can offer your course as
            free or paid. However, some small processing or platform fees may
            apply for paid courses. Check our{" "}
            <a
              style={{ color: "#004FE0" }}
              href="https://support.mytakbir.com/article/85-teachers-revenue-share-at-takbir"
            >
              Revenue Share Policy
            </a>{" "}
            for further details!
          </div>
        </div>
      ),
    },

    {
      id: "8",
      qus: "Can a learner preview a course before purchasing?",
      ans: (
        <div>
          <div style={{ fontWeight: "600", marginBottom: "8px" }}>
            Many teachers offer a free preview of their courses or sample
            lessons.
          </div>
          <div>
            This helps you understand the style and content before you decide to
            enroll or make a payment.
          </div>
        </div>
      ),
    },

    {
      id: "9",
      qus: "What support can a teacher get from Takbir?",
      ans: (
        <div>
          <div>
            At Takbir, you can teach independently or can partner with our{" "}
            <strong style={{ fontWeight: "600" }}>
              Teaching Resource and Success Team (TRST)
            </strong>{" "}
            to get help with planning, video production, graphics, and course
            promotion. Check our{" "}
            <a
              style={{ color: "#004FE0" }}
              href="https://support.mytakbir.com/article/90-course-creation-pathways"
            >
              course creation pathways and guidelines
            </a>{" "}
            for further details!
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      {/*  ------------  */}
      <Script
        strategy="lazyOnload"
        src={`https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_MAIN}`}
      />
      <Script strategy="lazyOnload">
        {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_MAIN}', {
                    page_path: window.location.pathname,
                    });
                `}
      </Script>
      {/* --------------- */}
      <Head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="theme-color" content="#000000" />
        <meta
          name="robots"
          content={
            process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
              ? "index, follow"
              : "noindex, nofollow"
          }
        />
        <meta
          name="googlebot"
          content={
            process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
              ? "index, follow"
              : "noindex, nofollow"
          }
        />
        <meta name="referrer" content="no-referrer-when-downgrade" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />

        <title>Takbir - Best online Islamic learning and teaching site</title>
        <meta
          name="description"
          content="Takbir is a secured, simple and easy-to-use online learning platform for learners and teachers of Islam. Learn Islam, Iman, Ihsan, Tazkiya, Akhlaq, Quran, Hadith, Fiqh, Arabic and much more in one place."
        />
        <meta
          property="og:site_name"
          content="Takbir - Best online Islamic learning and teaching site "
        />
        <meta
          property="og:description"
          content="Takbir is a secured, simple and easy-to-use online learning platform for learners and teachers of Islam. Learn Islam, Iman, Ihsan, Tazkiya, Akhlaq, Quran, Hadith, Fiqh, Arabic and much more in one place."
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:url" content="https://mytakbir.com/" />
        <meta
          property="og:title"
          content="Takbir - Best online Islamic learning and teaching site"
        />
        <meta
          property="og:image"
          content="https://cdn.mytakbir.com/static-assets/meta/web-takbir-img.png"
        />
        <meta
          property="og:image:secure_url"
          content="https://cdn.mytakbir.com/static-assets/meta/web-takbir-img.png"
        />

        <link
          rel="icon"
          href="https://cdn.mytakbir.com/static-assets/meta/takbir-lms-learning-management-system-muslim-favicon.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon.ico" />
        {/* <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" /> */}

        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-7XY3WGDSHE"
        ></script>

        <script id="google-analytics" strategy="afterInteractive">
          {`
                            window.dataLayer = window.dataLayer || [];
                               function gtag(){window.dataLayer.push(arguments);}
                                gtag('js', new Date());
                                   gtag('config', 'G-7XY3WGDSHE');
                                  `}
        </script>

        
        <Script id="mixpanel" strategy="afterInteractive">
          {`
            (function(e,c){
              if(!c.__SV){
                var l,h;window.mixpanel=c;c._i=[];
                c.init=function(q,r,f){
                  function t(d,a){
                    var g=a.split(".");
                    2==g.length&&(d=d[g[0]],a=g[1]);
                    d[a]=function(){
                      d.push([a].concat(Array.prototype.slice.call(arguments,0)))
                    }
                  }
                  var b=c;
                  "undefined"!==typeof f?b=c[f]=[]:f="mixpanel";
                  b.people=b.people||[];
                  b.toString=function(d){
                    var a="mixpanel";
                    "mixpanel"!==f&&(a+="."+f);
                    d||(a+=" (stub)");
                    return a
                  };
                  b.people.toString=function(){
                    return b.toString(1)+".people (stub)"
                  };
                  l="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders start_session_recording stop_session_recording people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");
                  for(h=0;h<l.length;h++) t(b,l[h]);
                  var n="set set_once union unset remove delete".split(" ");
                  b.get_group=function(){
                    function d(p){
                      a[p]=function(){
                        b.push([g,[p].concat(Array.prototype.slice.call(arguments,0))])
                      }
                    }
                    for(var a={},g=["get_group"].concat(Array.prototype.slice.call(arguments,0)),m=0;m<n.length;m++) d(n[m]);
                    return a
                  };
                  c._i.push([q,r,f])
                };
                c.__SV=1.2;
                var k=e.createElement("script");
                k.type="text/javascript";
                k.async=!0;
                k.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL
                  ? MIXPANEL_CUSTOM_LIB_URL
                  : ("file:" === e.location.protocol && "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\\/\\//)
                    ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js"
                    : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js");
                var s=e.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(k,s)
              }
            })(document,window.mixpanel||[]);

            mixpanel.init("60e7a8f3c95c4e2b186ace1f2dc5aa09", {
              autocapture: true,
              record_sessions_percent: 100
            });
          `}
        </Script>

      </Head>

      <SimpleBackdrop open={openBackdrop} />
      <CustomizedSnackbar
        open={showSnackbar}
        severity={snackbarSeverity}
        message={snackbarMessage}
        handleClose={handleSnackbarClose}
      />
      <Header
        subdomain={subdomain}
        updateCart={updateCart}
        setUpdateCart={setUpdateCart}
        openSignUpModel={openSignUpModel}
        enrollNowHandler={enrollNowHandler}
        setOpenSignUpModel={setOpenSignUpModel}
      />
      <Banner />
      <ExploreCourse
        filterCheckBoxData={filterCheckBoxData}
        updateCart={updateCart}
        setUpdateCart={setUpdateCart}
        openSignUpModel={openSignUpModel}
        setOpenSignUpModel={setOpenSignUpModel}
        enrollNowHandler={enrollNowHandler}
        showSnackbarMessage={showSnackbarMessage}
      />
      <ExploreTrstCourses 
        filterCheckBoxData={filterCheckBoxData}
        updateCart={updateCart}
        setUpdateCart={setUpdateCart}
        openSignUpModel={openSignUpModel}
        setOpenSignUpModel={setOpenSignUpModel}
        enrollNowHandler={enrollNowHandler}
        showSnackbarMessage={showSnackbarMessage}
      />
      <UpcomingCourses />
      <LearnSunnahFromScholars />
      <LearnFromOurTeacher setOpenSignUpModel={setOpenSignUpModel} />
      <InstitutionsTeaching />
      {/* <FeaturedTeaching /> */}
      {/* <Aboutus />
      <BecomeaTeacher /> */}
      <Faq faqData={faqData} />
      {/* <OthersProducts /> */}
      <BlogHome />
      <Footer />
      {/* <StickyFooter /> */}
      {Object?.keys(userData)?.length > 0 && <StickyFooter />}

      {/* <InstallationPrompt /> */}
    </>
  );
};

// export async function getServerSideProps() {

//   const apiBaseUrl = process.env.NEXT_PUBLIC_PROJECT_ENV === 'prod' ? process.env.NEXT_PUBLIC_API_URL_PROD : process.env.NEXT_PUBLIC_API_URL_DEV;
//   console.log(apiBaseUrl);
//   try {
//     const response = await fetch(`${apiBaseUrl}/getFilterCheckBoxData`);
//     const filterCheckBoxData = await response.json();
//     console.log(filterCheckBoxData);
//     return {
//       props: {
//         filterCheckBoxData: filterCheckBoxData
//       },
//     };
//   } catch (error) {
//     console.error('Error fetching data on server side:', error);
//     return {
//       props: {},
//     };
//   }
// }

export default MyTakbirHome;
